/**
 * PORTED — RO-3-00 / #44398.
 * Origin: `excellent/app/projects/[projectSlug]/[sectionSlug]/_hiring/scope-actions.tsx`
 * (verbatim except the two import paths). See `finance-scope-actions.tsx` for why
 * the three stay separate files.
 */

import { DataScopeActions } from "@excellent/ui";
import { DataImportClient } from "../data-import/client";
import { ObjectsIndexClient, type ObjectKindRow } from "./objects-index-client";
import { HIRING_KINDS } from "./scope-kinds";

export function HiringScopeActions({ rawRows }: { rawRows: ObjectKindRow[] }) {
  return (
    <DataScopeActions
      entityLabel="Candidates"
      importDescription="Upload a CSV, TSV, or JSON of candidates — rows land as people via the Schema, deduped by email."
      import={<DataImportClient targetKind="hiring-candidates" />}
      rawDataDescription="The person table behind this page, scoped to Hiring."
      rawData={
        <ObjectsIndexClient
          rows={rawRows}
          scopeKinds={[...HIRING_KINDS]}
          chromeless
        />
      }
    />
  );
}
